import React from 'react'

const Footer = () => {
	const currentYear = new Date().getFullYear()

	return (
		<footer className='bg-secondry p-4 w-full mt-auto'>
			<div className='container-fluid py-1'>
				<span className='f-14 font-weight-normal text-white'>
					Copyright {currentYear} 4473 Cloud Back-Office, LLC. All Rights
					Reserved. Privacy Policy
				</span>
			</div>
		</footer>
	)
}

export default Footer
